import { Bar } from 'vue-chartjs'

export default {
  extends: Bar,
  props: {
    chartData: {
      type: Object,
      default: null
    },
    options: {
      type: Object,
      default: null
    }
  },
  mounted () {
    this.renderChart(this.chartData, this.options);
    this.$root.$on("update:chart", ()=>{
      this.$data._chart.update();
    })
  },
  watch: {
    chartData () {
      this.$data._chart.update()
    }
  }
}